import React from 'react';

import MuiSkeleton from '@mui/material/Skeleton';

export interface SkeletonProps {
  className?: string;
  dataFd?: string;
  variant?: 'circle' | 'text' | 'rect';
}

export function Skeleton({
  className,
  dataFd,
  variant,
}: SkeletonProps): JSX.Element {
  const getMuiVariant = (fdVariant) => {
    switch (fdVariant) {
      case 'circle':
        return 'circular';
      case 'rect':
        return 'rectangular';
      default:
        return 'text';
    }
  };

  return (
    <MuiSkeleton
      data-fd={dataFd}
      className={className}
      variant={getMuiVariant(variant)}
    />
  );
}
